export default __webpack_public_path__ + "static/media/Deacon's Straps of the Hallow Worlds.6f359f59.jpg";